import { NavigateFunction } from 'react-router-dom';
import { AnyAction, Dispatch } from 'redux';
import { HEALER_PROFILE_ROUTE } from '../../../store/selectors/global.selector';
import { AppState } from '../../../store/store';
import { ThunkResult } from '../shared/ThunkResult';

export const navigateToHealerProfileAction = (navigate: NavigateFunction): ThunkResult<void> => {
  return async (dispatch: Dispatch<AnyAction>, getState: () => AppState) => {
    navigate(HEALER_PROFILE_ROUTE);
  };
};